(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_product-card"] && !Shopify.designMode) return;
  try {
    (function () {
    if (window.SupermenKortblok) return;
    window.SupermenKortblok = true;
    var R = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

    // Packshots på hvid bund lægges ind på den grå flade (samme billedscript som produktsiden)
    function klar(root) {
      var S = window.SupermenVare;
      if (!S || !S.sampleBg) return;
      Array.prototype.forEach.call((root || document).querySelectorAll('.spd-kortblok [data-bg]'), S.sampleBg);
    }
    window.SupermenKortKlar = klar;

    var toast, toastT;
    function vis(html, fejl) {
      if (!toast) {
        toast = document.createElement('div');
        toast.className = 'spd spd-toast';
        toast.setAttribute('role', 'status');
        toast.setAttribute('aria-live', 'polite');
        document.body.appendChild(toast);
      }
      toast.innerHTML = html;
      toast.classList.toggle('is-fejl', !!fejl);
      void toast.offsetWidth;
      toast.classList.add('is-vist');
      window.clearTimeout(toastT);
      toastT = window.setTimeout(function () { toast.classList.remove('is-vist'); }, 4500);
    }
    function esc(s) {
      return String(s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; });
    }

    // Læg i kurv fra kortet. På produktsiden åbner kurven; andre steder kommer en kort besked.
    function tilfoej(knap) {
      if (knap.classList.contains('is-busy')) return;
      var kort = knap.closest('.spd-kort');
      var navn = kort && kort.querySelector('.spd-kort__navn');
      navn = navn ? navn.firstChild.textContent.trim() : '';
      var items = [{ id: +knap.dataset.spdAdd, quantity: 1 }];
      knap.classList.add('is-busy');
      function ok() {
        knap.classList.remove('is-busy');
        knap.classList.add('is-ok');
        window.setTimeout(function () { knap.classList.remove('is-ok'); }, 2400);
      }
      function fejl(msg) {
        knap.classList.remove('is-busy');
        vis(esc(msg), true);
      }
      if (document.querySelector('[data-spd-vare][data-ready]')) {
        document.dispatchEvent(new CustomEvent('supermen:add', { detail: { items: items, onSuccess: ok, onError: fejl } }));
        return;
      }
      fetch(R + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: items })
      }).then(function (r) {
        return r.json().catch(function () { return {}; }).then(function (j) {
          if (!r.ok) throw new Error(j.description || 'Varen kunne ikke lægges i kurven. Prøv igen.');
        });
      }).then(function () {
        return fetch(R + 'cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); });
      }).then(function (cart) {
        ok();
        document.dispatchEvent(new CustomEvent('cart:update', { bubbles: true, detail: { resource: cart, sourceId: 'supermen-kort', data: { source: 'supermen-kort', itemCount: cart.item_count } } }));
        var str = knap.dataset.spdValgNavn ? ', ' + knap.dataset.spdValgNavn : '';
        vis('<svg class="spd-ikon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" aria-hidden="true"><path d="M5 12.5l4.5 4.5L19 7.5"/></svg><span>' + esc(navn + str) + ' er lagt i kurven.</span><a href="' + R + 'cart">Se kurven</a>');
      }).catch(function (e) { fejl(e.message); });
    }
    document.addEventListener('click', function (e) {
      var k = e.target.closest && e.target.closest('.spd-kortblok [data-spd-add]');
      if (k && !k.disabled) { e.preventDefault(); tilfoej(k); }
    });

    function init() { klar(document); }
    // Venter et øjeblik, så billedscriptet i Supermen vare er klar, uanset rækkefølgen i temaets samlede fil
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { window.setTimeout(init, 0); });
    else window.setTimeout(init, 0);
    document.addEventListener('shopify:section:load', function (e) { klar(e.target); });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["filters"] && !Shopify.designMode) return;
  try {
    (function () {
    if (window.SupermenFiltre) return;
    window.SupermenFiltre = true;
    var mobil = window.matchMedia('(max-width: 989px)');
    var styring = null;

    function alle(root, sel) { return Array.prototype.slice.call(root.querySelectorAll(sel)); }
    function vaert(root) { return root.closest('.shopify-section') || document.body; }
    function sig(root, tekst) {
      var s = root.querySelector('[data-spf-status]');
      if (!s) return;
      s.textContent = '';
      window.setTimeout(function () { s.textContent = tekst; }, 80);
    }

    // Adressen ud fra formularen: tomme felter (f.eks. pris) tages ikke med
    function adresse(root) {
      var form = root.querySelector('[data-spf-form]');
      var p = new URLSearchParams();
      new FormData(form).forEach(function (v, k) { if (String(v).trim() !== '') p.append(k, v); });
      var s = p.toString();
      return form.getAttribute('action') + (s ? '?' + s : '');
    }

    /* ---------- Hent nye varer og opdatér siden ---------- */
    function hent(root, href, skub) {
      var host = vaert(root);
      var u = new URL(href, window.location.href);
      u.searchParams.delete('page');
      u.searchParams.delete('section_id');
      // Sektioner uden vores varegitter (f.eks. Horizons søgeside) genindlæses som en almindelig side
      if (!host.querySelector('[data-spf-del="resultater"]')) { window.location.assign(u.toString()); return; }
      var hentU = new URL(u.toString());
      hentU.searchParams.set('section_id', root.dataset.section);
      if (styring) styring.abort();
      styring = 'AbortController' in window ? new AbortController() : null;
      host.classList.add('spf-henter');
      return fetch(hentU.toString(), { signal: styring ? styring.signal : undefined })
        .then(function (r) { if (!r.ok) throw new Error(r.status); return r.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          opdater(root, host, doc);
          var ny = u.pathname + u.search;
          if (skub) window.history.pushState({ spf: root.dataset.section }, '', ny);
          host.classList.remove('spf-henter');
          var antal = root.querySelector('[data-spf-del="antal"]');
          sig(root, (antal ? antal.textContent.trim() : '') + ' vises.');
        })
        .catch(function (e) {
          if (e && e.name === 'AbortError') return;
          window.location.assign(u.toString());
        });
    }

    function opdater(root, host, doc) {
      var aktiv = document.activeElement, fokusId = aktiv && host.contains(aktiv) ? aktiv.id : '';
      // 1. Felter og knapper på stedet, så åbne menuer, rulning og fokus bliver, hvor de er
      alle(host, '[data-spf-liste]').forEach(function (liste) {
        var ny = doc.querySelector('[data-spf-liste="' + liste.dataset.spfListe + '"]');
        if (!ny) return;
        var gamle = alle(liste, '[data-spf-input]').map(function (i) { return i.id; }).join('|');
        var nye = alle(ny, '[data-spf-input]').map(function (i) { return i.id; }).join('|');
        if (gamle !== nye) {
          var udvidet = liste.dataset.udvidet;
          liste.innerHTML = ny.innerHTML;
          if (udvidet) alle(liste, '[data-spf-ekstra]').forEach(function (li) { li.hidden = false; });
          return;
        }
        alle(liste, '[data-spf-input]').forEach(function (inp) {
          var n = ny.querySelector('#' + CSS.escape(inp.id));
          if (!n) return;
          inp.checked = n.checked;
          inp.disabled = n.disabled;
          var a = inp.parentNode.querySelector('[data-spf-antal]'), na = n.parentNode.querySelector('[data-spf-antal]');
          if (a && na) a.textContent = na.textContent;
        });
      });
      alle(host, '[data-spf-pris]').forEach(function (inp) {
        var n = doc.getElementById(inp.id);
        if (!n) return;
        if (inp !== document.activeElement) inp.value = n.value;
        inp.placeholder = n.placeholder;
      });
      var nsort = doc.querySelector('[data-spf-sort]:checked');
      if (nsort) alle(root, '[data-spf-sort]').forEach(function (r) { r.checked = r.value === nsort.value; });
      // 2. Tekster, valgte filtre og varerne skiftes ud
      alle(host, '[data-spf-del]').forEach(function (el) {
        var n = doc.querySelector('[data-spf-del="' + el.dataset.spfDel + '"]');
        if (n) el.replaceWith(document.importNode(n, true));
      });
      if (fokusId && !document.getElementById(fokusId)) fokusId = '';
      if (fokusId && document.activeElement !== document.getElementById(fokusId)) document.getElementById(fokusId).focus({ preventScroll: true });
      if (window.SupermenKortKlar) window.SupermenKortKlar(host);
      taethed(root);
      host.dispatchEvent(new CustomEvent('supermen:filtre', { bubbles: true }));
    }

    /* ---------- Panel på mobil ---------- */
    function aabn(root, knap) {
      var panel = root.querySelector('[data-spf-panel]'), slor = root.querySelector('.spf-slor');
      if (!panel) return;
      root._knap = knap;
      panel.setAttribute('role', 'dialog');
      panel.setAttribute('aria-modal', 'true');
      panel.classList.add('is-aaben');
      if (slor) slor.hidden = false;
      knap.setAttribute('aria-expanded', 'true');
      document.documentElement.classList.add('spf-laast');
      // Grupper med valg er åbne; ellers den første
      var g = alle(panel, '[data-spf-gruppe]');
      var valgt = g.filter(function (d) { return d.querySelector('input:checked') || alle(d, '[data-spf-pris]').some(function (i) { return i.value; }); });
      (valgt.length ? valgt : g.slice(0, 1)).forEach(function (d) { d.open = true; });
      window.setTimeout(function () { var l = panel.querySelector('.spf-panel__luk'); if (l) l.focus(); }, 60);
    }
    function luk(root) {
      var panel = root.querySelector('[data-spf-panel]'), slor = root.querySelector('.spf-slor');
      if (!panel || !panel.classList.contains('is-aaben')) return;
      panel.classList.remove('is-aaben');
      panel.setAttribute('role', 'region');
      panel.removeAttribute('aria-modal');
      if (slor) slor.hidden = true;
      document.documentElement.classList.remove('spf-laast');
      var k = root._knap || root.querySelector('[data-spf-aabn]');
      if (k) { k.setAttribute('aria-expanded', 'false'); k.focus(); }
    }
    function faelde(root, e) {
      var panel = root.querySelector('[data-spf-panel].is-aaben');
      if (!panel) return;
      var f = alle(panel, 'a[href], button:not([disabled]), input:not([disabled]), select, summary, [tabindex]:not([tabindex="-1"])').filter(function (x) { return x.offsetParent !== null || x.tagName === 'SUMMARY'; });
      if (!f.length) return;
      var forste = f[0], sidste = f[f.length - 1];
      if (e.shiftKey && document.activeElement === forste) { e.preventDefault(); sidste.focus(); }
      else if (!e.shiftKey && document.activeElement === sidste) { e.preventDefault(); forste.focus(); }
    }

    /* ---------- Små menuer på computer: én ad gangen ---------- */
    function lukMenuer(root, undtagen) {
      if (mobil.matches || !root.querySelector('.spf--bar, .spf-gruppe')) return;
      if (!root.classList.contains('spf--bar')) return;
      alle(root, '[data-spf-gruppe][open]').forEach(function (d) { if (d !== undtagen) d.open = false; });
    }

    /* ---------- Billedstørrelse ---------- */
    var lilleSkaerm = window.matchMedia('(max-width: 749px)');
    function noegle() { return 'spl-taethed-' + (lilleSkaerm.matches ? 'm' : 'd'); }
    // Uden eget valg: på mobil det, der er sat i temaet (2 pr. række = små billeder), ellers store billeder
    function hentValg(gitter) {
      var v = null;
      try { v = window.localStorage.getItem(noegle()); } catch (e) {}
      if (v === 'stor' || v === 'lille') return v;
      return lilleSkaerm.matches ? (gitter.dataset.splStdM || 'lille') : 'stor';
    }
    function taethed(root, valg) {
      var gruppe = root.querySelector('[data-spf-taethed-gruppe]');
      if (!gruppe) return;
      var gitre = alle(vaert(root), '[data-spl-gitter]');
      gruppe.hidden = !gitre.length;
      if (!gitre.length) return;
      if (valg) { try { window.localStorage.setItem(noegle(), valg); } catch (e) {} }
      valg = valg || hentValg(gitre[0]);
      gitre.forEach(function (g) { g.dataset.taethed = valg; });
      alle(gruppe, '[data-spf-taethed]').forEach(function (b) { b.setAttribute('aria-pressed', b.dataset.spfTaethed === valg ? 'true' : 'false'); });
    }

    /* ---------- Hændelser ---------- */
    var prisT;
    document.addEventListener('change', function (e) {
      var t = e.target;
      var root = t.form && t.form.closest('[data-spf]');
      if (!root && t.closest) root = t.closest('[data-spf]');
      if (!root) return;
      // Andre stavemåder af samme størrelse følger med det synlige felt
      if (t.dataset && t.dataset.spfTvillinger) t.dataset.spfTvillinger.split(' ').forEach(function (id) { var x = document.getElementById(id); if (x) x.checked = t.checked; });
      if (t.matches('[data-spf-sort]')) { var sm = t.closest('[data-spf-sortmenu]'); if (sm) { sm.open = false; sm.querySelector('summary').focus({ preventScroll: true }); } }
      if (t.matches('[data-spf-input], [data-spf-sort]')) hent(root, adresse(root), true);
      else if (t.matches('[data-spf-pris]')) { window.clearTimeout(prisT); hent(root, adresse(root), true); }
    });
    document.addEventListener('input', function (e) {
      var t = e.target;
      if (!t.matches || !t.matches('[data-spf-pris]')) return;
      var root = t.closest('[data-spf]');
      window.clearTimeout(prisT);
      prisT = window.setTimeout(function () { hent(root, adresse(root), true); }, 800);
    });
    document.addEventListener('submit', function (e) {
      var root = e.target.closest && e.target.closest('[data-spf]');
      if (!root || !e.target.matches('[data-spf-form]')) return;
      e.preventDefault();
      window.clearTimeout(prisT);
      hent(root, adresse(root), true);
    });
    document.addEventListener('keydown', function (e) {
      if (!e.target.matches || !e.target.matches('[data-spf-pris]') || e.key !== 'Enter') return;
      e.preventDefault();
      var root = e.target.closest('[data-spf]');
      window.clearTimeout(prisT);
      hent(root, adresse(root), true);
    });
    document.addEventListener('click', function (e) {
      var t = e.target;
      // Klik uden for en åben menu lukker den
      alle(document, '[data-spf].spf--bar').forEach(function (r) {
        if (!r.contains(t) || !t.closest('[data-spf-gruppe]')) lukMenuer(r);
      });
      alle(document, '[data-spf-sortmenu][open]').forEach(function (d) { if (!d.contains(t)) d.open = false; });
      var root = t.closest && t.closest('[data-spf]');
      if (!root) {
        var ud = t.closest && t.closest('a[data-spf-link]');
        var udRoot = ud && vaert(ud).querySelector('[data-spf]');
        if (udRoot) { e.preventDefault(); hent(udRoot, ud.href, true); }
        return;
      }
      var a = t.closest('a[data-spf-link]');
      if (a) { e.preventDefault(); hent(root, a.href, true); return; }
      var ab = t.closest('[data-spf-aabn]');
      if (ab) { aabn(root, ab); return; }
      if (t.closest('[data-spf-luk]')) { luk(root); return; }
      var fl = t.closest('[data-spf-flere]');
      if (fl) {
        var liste = fl.parentNode.querySelector('[data-spf-liste]');
        alle(liste, '[data-spf-ekstra]').forEach(function (li) { li.hidden = false; });
        liste.dataset.udvidet = '1';
        fl.remove();
        return;
      }
      var tb = t.closest('[data-spf-taethed]');
      if (tb) taethed(root, tb.dataset.spfTaethed);
    });
    document.addEventListener('toggle', function (e) {
      var d = e.target;
      if (!d.matches || !d.matches('[data-spf-gruppe]') || !d.open) return;
      var root = d.closest('[data-spf]');
      if (root) lukMenuer(root, d);
    }, true);
    document.addEventListener('keydown', function (e) {
      alle(document, '[data-spf]').forEach(function (root) {
        if (e.key === 'Escape') {
          var sm = root.querySelector('[data-spf-sortmenu][open]');
          if (sm) { sm.open = false; sm.querySelector('summary').focus(); return; }
          var aaben = root.querySelector('[data-spf-panel].is-aaben');
          if (aaben) { luk(root); return; }
          var menu = root.classList.contains('spf--bar') && !mobil.matches && root.querySelector('[data-spf-gruppe][open]');
          if (menu) { menu.open = false; menu.querySelector('summary').focus(); }
        }
        if (e.key === 'Tab') faelde(root, e);
      });
    });
    window.addEventListener('popstate', function () {
      alle(document, '[data-spf]').forEach(function (root) { hent(root, window.location.href, false); });
    });
    mobil.addEventListener && mobil.addEventListener('change', function () {
      alle(document, '[data-spf]').forEach(function (root) { luk(root); if (!mobil.matches) lukMenuer(root); });
    });
    lilleSkaerm.addEventListener && lilleSkaerm.addEventListener('change', function () {
      alle(document, '[data-spf]').forEach(function (root) { taethed(root); });
    });

    function init() { alle(document, '[data-spf]').forEach(function (r) { taethed(r); }); }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
    document.addEventListener('shopify:section:load', init);
  })();
  } catch(e) { console.error(e); }
})();

})();
